<template>
    <div class="partner" v-loading="showLoading">
        <el-form ref="ruleFormRef" style="max-width: 600px" :model="ruleForm" :rules="rules" label-width="auto">
            <el-form-item label="供应商名称" prop="supplierName">
                <el-input v-model="ruleForm.supplierName" placeholder="请填写供应商名称" />
            </el-form-item>
            <el-form-item label="所属合作方" prop="partnerCode">
                <el-select v-model="ruleForm.partnerCode" placeholder="请选择所属合作方" size="large">
                    <el-option v-for="item in options" :key="item.partnerCode" :label="item.abbreviation"
                        :value="item.partnerCode" />
                </el-select>
            </el-form-item>
            <el-form-item label="联系人" prop="contacts">
                <el-input v-model="ruleForm.contacts" placeholder="请填写联系人" />
            </el-form-item>
            <el-form-item label="手机号" prop="mobile">
                <el-input v-model="ruleForm.mobile" placeholder="请填写手机号" />
            </el-form-item>
            <el-form-item label="邮箱">
                <el-input v-model="ruleForm.email" placeholder="请填写邮箱" />
            </el-form-item>
            <el-form-item label="地址">
                <el-input v-model="ruleForm.address" placeholder="请填写地址" />
            </el-form-item>
            <el-form-item label="备注">
                <el-input v-model="ruleForm.remarks" type="textarea" />
            </el-form-item>
            <el-form-item>
                <!-- 绑定 loading 状态 -->
                <el-button type="primary" @click="submitForm(ruleFormRef)" :loading="submitLoading"
                    :disabled="submitLoading">
                    提交
                </el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue';
import { ElMessage } from 'element-plus';
import { useRouter } from 'vue-router'; // 引入路由
import {
    editSupplierData, getpartnerData, getSupplierDetail
} from "../../../request/api";
import qs from 'qs';
import { isRequestErrorHandled } from '../../../request/authExpired';
const router = useRouter(); // 获取路由实例

const ruleFormRef = ref();
// 添加提交加载状态
const submitLoading = ref(false);
const showLoading = ref(true);
//合作方列表
const options = ref([]);
// 使用 reactive 创建响应式对象
const ruleForm = reactive({
    supplierName: '', //供货商名称
    partnerCode: '', //所属合作方
    contacts: '', //联系人姓名
    mobile: '', //手机号
    email: '', //邮箱
    address: '', //地址
    remarks: '', //备注
})
onMounted(() => {
    partnerList(); //合作方数据 
    fetchSupplierDetail();
})
const partnerList = () => {
    getpartnerData().then((res) => {
        if (res.data.code == 0) {
            options.value = res.data.data.partnerCodeList;
        }
    })
}
// 获取合作方详情
const fetchSupplierDetail = async () => {    
    try {
        const params = {
            id: sessionStorage.getItem('supplierId'), // 替换为实际的合作方ID
        }
        getSupplierDetail(qs.stringify(params)).then((res) => {
            if (res.data.code === 0) {
                Object.assign(ruleForm, res.data.data.supplierInfo);
                showLoading.value = false;
            } else {
                ElMessage.error(res.data.msg || '获取供应商详情失败');
            }
        })
    } catch (error) {
        
        ElMessage.error('获取供应商详情出错');
    }
};
const rules = {
    supplierName: [
        { required: true, message: '请填写供货商名称', trigger: 'blur' },
    ],

    partnerCode: [
        {
            required: true,
            message: '请选择所属合作方',
            trigger: 'change',
        },
    ],
    contacts: [
        { required: true, message: '请填写联系人', trigger: 'blur' },
    ],
    mobile: [
        { required: true, message: '请填写手机号', trigger: 'blur' },
    ],
}
// 提交表单
const submitForm = async (formEl) => {
    if (!formEl) return;

    // 如果正在提交中，直接返回
    if (submitLoading.value) return;

    try {
        submitLoading.value = true; // 开始加载

        // 先进行表单验证
        await formEl.validate();
        // 准备请求参数
        const params = {
            id: sessionStorage.getItem('supplierId'), // 替换为实际的合作方ID
            supplierName: ruleForm.supplierName, //供货商名称
            partnerCode: ruleForm.partnerCode, //所属合作方
            contacts: ruleForm.contacts, //联系人姓名
            mobile: ruleForm.mobile, //手机号
            email: ruleForm.email, //邮箱
            address: ruleForm.address, //地址
            remarks: ruleForm.remarks, //备注
        };
        // 调用API
        editSupplierData(params).then((res) => {
            if (res.data.code == 0) {
                ElMessage.success('编辑成功');
                submitLoading.value = false; // 结束加载
                setTimeout(() => {
                    router.push('/supplierManagement');
                }, 1000);
            } else {
                 ElMessage.error(res.data.msg || '编辑失败');
                 submitLoading.value = false; // 结束加载
                throw new Error(res.data.message || '添加失败');
            }
        })
    } catch (error) {
        submitLoading.value = false; // 结束加载
        // 如果是表单验证错误，Element会自动显示错误信息
        if (!isRequestErrorHandled(error) && error.message !== '表单验证失败') {
            ElMessage.error(error.message || '提交失败');
        }
    }
};

</script>

<style lang="scss" scoped>
.partner {
    height: calc(100vh - 170px);
    background-color: #FFFFFF;
    width: 95%;
    padding: 20px;
    overflow: auto;
    box-shadow: var(--el-box-shadow-light);
    border-radius: 5px;
    margin: 15px auto;
}

.avatar-uploader .avatar {
    width: 110px;
    height: 110px;
    display: block;
}

.upload-wrapper {
    display: flex;
    align-items: flex-end;
    /* 使子元素底部对齐 */
    gap: 10px;
    /* 设置元素之间的间距 */
}

.recommend-tip {
    color: #cccccc;
}

/* 新增的图片容器样式 */
.image-container {
    position: relative;

    &:hover .image-actions {
        opacity: 1;
    }
}

.image-actions {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 15px;
    opacity: 0;
    transition: opacity 0.3s;
}

.action-icon {
    color: white;
    font-size: 24px;
    cursor: pointer;

    &:hover {
        color: var(--el-color-primary);
    }
}
</style>

<style>
.avatar-uploader .el-upload {
    border: 1px dashed var(--el-border-color);
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: var(--el-transition-duration-fast);
}

.avatar-uploader .el-upload:hover {
    border-color: var(--el-color-primary);
}

.el-icon.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 110px;
    height: 110px;
    text-align: center;
}

.avatar-uploader .el-upload-list__item {
    width: 110px;
    height: 110px;
}

.el-upload-list__item-thumbnail {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.el-form-item__label-wrap .el-form-item__label {
    font-weight: bold;
}

.el-upload-list__item {
    margin-bottom: 0;
}

.hint_box {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;

    .hint_title {
        width: 120px;
        text-align: right;
        color: #909399;
        font-weight: bold;
    }

    .hint_text {
        color: #909399;
        font-size: 14px;
    }
}

.el-input__inner {
    height: 38px !important;
    line-height: 38px !important;
}
</style>
